import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByNumberType',
  pure: true
})
export class GroupByNumberTypePipe implements PipeTransform {
  transform(items: any[]): { standard: any[]; virtual: any[] } {
    if (!Array.isArray(items)) {
      return { standard: [], virtual: [] };
    }

    return {
      standard: items.filter(item => !item.isVirtualNumber),
      virtual: items.filter(item => item.isVirtualNumber)
    };
  }
}
